import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

import VueHead from 'vue-head';
Vue.use(VueHead);

Vue.config.productionTip = false;

import { remax } from './api';

new Vue({
  router,
  store,

  created () {
    const token = window.localStorage.getItem('token');

    if (token) { 
      this.$store.dispatch('getUser', token);
    }

    remax.getLookUps()
      .then(({ data }) => {
        this.$store.commit('updateProvinces', data.Provinces);
        this.$store.commit('updateTowns', data.Towns);

        const { PropertyTypes, PropertyMacroTypes } = data;
        this.$store.commit('updatePropertyTypes', { PropertyTypes, PropertyMacroTypes });
      })
      .catch(({ data }) => console.log(data))
  },

  render: h => h(App)
}).$mount('#app')
